/*
  ELÛNA, productpagina gallery: doorlopen bij VEGEN. 21-08-2026.

  Wat hier wel en niet in zit, en waarom dat belangrijk is:
  De pijlknoppen loopten al. Dit thema draait geen standaard Dawn maar een eerder aangepaste
  media-gallery.js met een eigen `onNavButtonClick` die met een modulo rekent, plus een
  `houdKnoppenKlikbaar()` die het disabled-attribuut met een MutationObserver weghaalt.
  Gemeten 21-08-2026 op het live thema (16.1.1): klik op volgende bij slide 7 van 7 zet de
  teller op 1/7, is-active op slide 1 en scrollLeft op 0. De knop is dus in orde.

  Wat NIET werkte is de veeg. Sta je op de laatste slide (een video) en veeg je verder naar
  links, dan gebeurt er niets: de lijst scrollt native met scroll-snap en er is niets meer om
  naartoe te scrollen. Dit bestand dekt alleen dat gat.

  Een eerdere versie van dit bestand onderschepte ook de KLIK en deed een eigen scrollTo. Dat
  was dubbelop en het brak de teller: de pagina sprong wel naar slide 1 maar de teller bleef
  op 7/7 staan, omdat de eigen scroll het bestaande setActiveMedia oversloeg. Vandaar dat de
  sprong hieronder via setActiveMedia gaat: die zet is-active, de teller, de thumbnail en start
  de video van de nieuwe slide. Bouw hier geen tweede mechanisme naast.

  Waarom "op de laatste slide" aan de SLIDE wordt gemeten en niet aan de scrollpositie:
  gemeten op 390px breed staat de laatste slide op offsetLeft 2400 terwijl de maximale
  scrollpositie 2415 is. Die 15px staartruimte hoort bij de slider zelf. Een test op
  `scrollLeft >= maxScroll` wordt daardoor nooit waar en de loop springt nooit.
*/
(function () {
  'use strict';

  var EDGE = 8;   // px speling, ruim binnen de 400px die twee slides uit elkaar liggen
  var SWIPE = 40; // px minimale veeg voordat we hem als bedoeld lezen

  function setup(root) {
    if (!root || !root.querySelector) return;
    var gallery = root.querySelector('.product__media-wrapper media-gallery');
    if (!gallery) gallery = root.querySelector('media-gallery');
    if (!gallery || gallery.dataset.elunaSwipeLoop === '1') return;

    var slider = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (!slider) return;
    if (slides().length < 2) return;

    gallery.dataset.elunaSwipeLoop = '1';

    // De lijst wordt bij elke aanroep opnieuw uitgelezen: bij een variantwissel kan het aantal
    // slides veranderen, en een slide met breedte 0 doet niet mee.
    function slides() {
      return Array.prototype.filter.call(
        slider.querySelectorAll('[id^="Slide-"]'),
        function (el) {
          return el.clientWidth > 0;
        }
      );
    }
    function atEnd() {
      var s = slides();
      return s.length ? slider.scrollLeft >= s[s.length - 1].offsetLeft - EDGE : false;
    }
    function atStart() {
      var s = slides();
      return s.length ? slider.scrollLeft <= s[0].offsetLeft + EDGE : false;
    }
    // Kevin, 21 augustus 2026: "zorg dat de laatste swipe heel smooth voelt".
    //
    // Waarom dit een FADE is en geen smooth scroll. Een loop van de laatste naar de eerste
    // slide overbrugt hier 2310px (gemeten op 375px breed, 7 slides). Met
    // behavior:'smooth' raast de bezoeker dan alle zes tussenliggende slides voorbij; dat
    // duurt bijna een seconde en leest als terugspoelen, niet als doorlopen. Een korte
    // cross-fade verbergt de sprong en houdt hem kort. Dat is ook wat de referentie-carousels
    // doen bij een wrap.
    //
    // De sprong zelf blijft op 'auto' en blijft via setActiveMedia lopen, zodat teller,
    // thumbnail, is-active en de video-autoplay precies blijven werken zoals het thema dat al
    // deed. De fade raakt alleen de opacity.
    var FADE = 150; // ms per helft, dus 300ms totaal

    function springDirect(slide) {
      if (typeof gallery.setActiveMedia === 'function' && slide.dataset.mediaId) {
        // het bestaande pad: zet is-active, teller, thumbnail, en speelt de video af
        gallery.setActiveMedia(slide.dataset.mediaId, false);
      } else {
        slider.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
      }
    }

    function goTo(slide) {
      if (!slide) return;

      // Wie beweging heeft uitgezet krijgt de harde sprong, zonder fade.
      var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (rustig) {
        springDirect(slide);
        return;
      }

      slider.style.transition = 'opacity ' + FADE + 'ms ease';
      slider.style.opacity = '0';

      window.setTimeout(function () {
        springDirect(slide);
        // twee frames wachten: een enkele rAF vuurt soms nog voor de sprong is gerenderd,
        // en dan zie je de nieuwe slide alsnog binnenspringen in plaats van opkomen.
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            slider.style.opacity = '1';
          });
        });
      }, FADE);
    }

    var startX = null;
    var startedAtEnd = false;
    var startedAtStart = false;

    slider.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || event.touches.length !== 1) {
          startX = null;
          return;
        }
        startX = event.touches[0].clientX;
        startedAtEnd = atEnd();
        startedAtStart = atStart();
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchend',
      function (event) {
        if (startX === null) return;
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch) {
          startX = null;
          return;
        }
        var dx = touch.clientX - startX;
        startX = null;
        var list = slides();
        if (list.length < 2) return;

        // naar links vegen terwijl je op de laatste slide staat: terug naar de eerste
        if (dx < -SWIPE && startedAtEnd && atEnd()) {
          goTo(list[0]);
          return;
        }
        // naar rechts vegen terwijl je op de eerste staat: door naar de laatste
        if (dx > SWIPE && startedAtStart && atStart()) {
          goTo(list[list.length - 1]);
        }
      },
      { passive: true }
    );
  }

  function init() {
    setup(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // De sectie wordt opnieuw gerenderd bij een variantwissel en in de theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
